import React, { useState } from "react";
import AppTopbar from "../components/AppTopbar.jsx";
import { C, font } from "../lib/styles.js";

// Local-only verification harness for the top bar's mobile nav menu.
// Reachable at ?e2e=topbar on localhost (see main.jsx). No auth, no real data.
// Renders the shared AppTopbar with mock nav so the responsive nav menu can be
// exercised at phone width without logging in. Includes a long (6-item) nav to
// confirm the dropdown scales past the 3-tab Jobs case.

function Demo({ appName, navItems, defaultActive = 0 }) {
  const [activeNav, setActiveNav] = useState(defaultActive);
  return (
    <div data-testid={`bar-${appName}`} style={{ marginBottom: 28, border: `1px solid ${C.border}`, borderRadius: 8, background: C.surface }}>
      <AppTopbar
        appName={appName}
        navItems={navItems}
        userInitials="IV"
        userEmail="ivin@nycap3d.com"
        onGoHome={() => {}}
        onSignOut={() => {}}
        activeNav={activeNav}
        onNavChange={setActiveNav}
      />
      <div className="app-content" style={{ padding: 16, fontFamily: font, fontSize: 13, color: C.text }}>
        {appName} → active tab: <strong>{navItems[activeNav]}</strong>
      </div>
    </div>
  );
}

export default function E2ETopbarFixture() {
  return (
    <div style={{ minHeight: "100vh", background: C.bg, fontFamily: font, padding: 16 }}>
      <div style={{ fontSize: 11, color: C.amber, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 16 }}>
        Top bar nav — local test mode
      </div>
      <Demo appName="Jobs" navItems={["Dashboard", "Quotes", "Jobs"]} />
      {/* The CRM's v3 tab list. Inbox, Assistant and Tasks are retired and
          People is now Contacts; Segments, Campaigns and Content land in
          slices 4-6, and they are here because five tabs is the overflow case
          this fixture exists to show. */}
      <Demo appName="CRM" navItems={["Contacts", "Clients", "Segments", "Campaigns", "Content"]} />
      {/* worst-case label combos Codex flagged for 320px overflow */}
      <Demo appName="Ingest" navItems={["Capture Arrays", "Everything Else", "Equipment"]} defaultActive={1} />
      <Demo appName="SafeShare" navItems={["Deliveries", "Client Vaults"]} defaultActive={1} />
      {/* Longest name in APP_REGISTRY paired with its four tabs — the case most
          likely to truncate the breadcrumb's app name on a narrow desktop. */}
      <Demo appName="Traffic Control" navItems={["Machines", "Studio Map", "Transfers", "Backups"]} />
    </div>
  );
}
